
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useStoreSettingsTerminals } from '@/entities/user-terminal'

export const terminalsListBeforeEnter = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const storeSettingsTerminals = useStoreSettingsTerminals()
  const { fetchTerminals } = storeSettingsTerminals
  await fetchTerminals()
  next()
}
